<mat-card mat-dialog-close [class.reminder]="type && type == 'close'">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <!-- <ng-container *ngIf="task.task == 'follow_up'"> -->
      <!-- <mat-icon style="color: #3b9bff;">notifications_active</mat-icon> -->
      <div fxLayout="row" fxLayoutAlign="start center">
        <ng-container *ngIf="task.action == 'call'">
          <mat-icon class="red-color pin">lens</mat-icon>
          <strong class="ml-1 gray-color">Call Task</strong></ng-container
        >
        <ng-container *ngIf="task.action == 'email'">
          <mat-icon class="yellow-color pin">lens</mat-icon>
          <strong class="ml-1 gray-color">Send Email Task</strong>
        </ng-container>
        <ng-container *ngIf="task.action == 'followup'">
          <mat-icon class="green-color pin">lens</mat-icon>
          <strong class="ml-1 gray-color">Follow up Task</strong>
        </ng-container>
        <!-- </ng-container> -->
        <!-- <ng-container *ngIf="task.task == 'to_do'">
        <mat-icon class="green-color pin">lens</mat-icon>
        <strong class="ml-1 gray-color">Follow up Task</strong>
      </ng-container> -->
      </div>

      <mat-menu #appMenuSnooze="matMenu">
        <button mat-menu-item (click)="setSnooze(5)">5 minutes</button>
        <button mat-menu-item (click)="setSnooze(15)">15 minutes</button>
        <button mat-menu-item (click)="setSnooze(30)">30 minutes</button>
      </mat-menu>

      <button
        mat-icon-button
        [matMenuTriggerFor]="appMenuSnooze"
        (click)="$event.stopPropagation()"
        style="height: 32px;line-height: 32px;"
      >
        <mat-icon style="color: #3b9bff;">snooze</mat-icon>
      </button>
    </div>
    <mat-divider [inset]="true" class="mb-2"></mat-divider>
    <div fxLayout="row" fxLayoutAlign=" center">
      <img
        class="avatar-profile-header"
        onerror="this.src='../../../assets/images/icons/user.png';this.style='opacity:0.8';"
        src="{{ user.photo }}"
        alt="Avatar photo"
      />
      <div class="blue-color ml-1" style="font-size: 14px;">
        <strong class="detail-event">{{ task.taskInfo.name }}</strong>
        <br />
        <span class="detail-event">{{ task.taskInfo.description }}</span>
        <br />
        <div class="detail-event">
          <!-- <ng-container *ngIf="task.task == 'follow_up'"> -->
          <ng-container *ngIf="task.action == 'call'">
            <mat-icon
              svgIcon="icon_phone_blue"
              style="height: 16px;width:16px;"
            ></mat-icon>
            {{ task.taskInfo.phone }}
          </ng-container>
          <ng-container *ngIf="task.action == 'email'"
            ><mat-icon
              svgIcon="icon_email_yellow"
              style="height: 16px;width:16px;position:relative;top:3px"
            >
              email</mat-icon
            >
            {{ task.taskInfo.email }}
          </ng-container>
          <!-- <ng-container *ngIf="task.action == 'followup'">
            <mat-icon
              svgIcon="icon_task_green"
              style="width: 20px;height: 18px;position: relative;top: 4px;"
            ></mat-icon>
            Follow Up
          </ng-container> -->
          <!-- </ng-container> -->
          <!-- <ng-container *ngIf="task.task != 'follow_up'">
            <mat-icon
              svgIcon="icon_task_green"
              style="width: 20px;height: 18px;position: relative;top: 4px;"
            ></mat-icon>
            Follow Up
          </ng-container> -->
        </div>
      </div>
    </div>
    <mat-divider [inset]="true" class="mt-2"></mat-divider>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span
        class="detail-event date-event"
        style="font-size: 13px;margin-top: 4px;"
      >
        {{ task.date | date: 'MM/dd/yyyy':'OOOO' }} at
        {{ task.date | date: 'h:mm a':'OOOO' }}</span
      >
    </div>
  </div>
</mat-card>
<mat-divider></mat-divider>
